import { Euler, Quaternion, Vector2, Vector3 } from 'three';
import { ButtonComponent, ParentEvent, ResourcesManager, Tween, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { BUTTON_PRIMARY_COLOR, BUTTON_PRIMARY_TEXT_COLOR } from '../../styleConfig';
export default class JarModule extends ViewerModule {
    constructor(model, table, uiContainer, level) {
        super();
        this.uiObject.name = 'JarModule';
        this.model = model;
        this.model.position.z = 3.35;
        this.table = table;
        this.parentLevel = level;
        this.defaultPosition = model.position.clone();
        // this.addObject(this.uiContainer = uiContainer);
        this.uiContainer = uiContainer;
        this.initButton();
    }
    initButton() {
        this.addObject(this.applyButton = new ButtonComponent({
            type: 'flat',
            size: new Vector3(2.2, 2.2, 1),
            sizePx: new Vector2(256, 256),
            bordRadius: 0.03,
            background: { color: BUTTON_PRIMARY_COLOR.getStyle() },
            text: {
                value: 'Apply'.toUpperCase(),
                lineHeight: 34,
                style: { size: '48px', color: BUTTON_PRIMARY_TEXT_COLOR.getStyle(), family: 'Nunito', weight: '800' },
                margin: { top: 22, right: 45, bottom: 26, left: 45 },
            }
        }));
        this.applyButton.uiObject.position.set(-2.5831736994195826, -2.6729500711734735, 4.107728494627179);
        if (Viewer.controls.zController) {
            this.applyButton.uiObject.position.set(-3.58, 0, 0);
            // @ts-ignore
            this.applyButton.uiObject.scale.setScalar(1.5);
        }
        this.applyButton.uiObject.visible = false;
        this.uiContainer.add(this.applyButton.uiObject);
    }
    pourToScaleBowl() {
        let prevSliderValue = 0;
        this.applyButton.on('click', (event) => {
            // @ts-ignore
            if (this.parentLevel.lobby.app.pointerController.currentPointerObject
                !== this.parentLevel.lobby.app.pointerController.defaultPointerObject)
                return;
            ResourcesManager.getAudioManger().getAudio('sand_end_sound').play();
            this.applyButton.uiObject.visible = false;
            this.fire('to_pour', new ParentEvent('to_pour', prevSliderValue * 8));
            this.fire('scalesBowl_filled');
        });
        ResourcesManager.getAudioManger().getAudio('sand_start_sound').play();
    }
    visibilityShadow(visibility = true) {
        const pPlane = this.model.getObjectByName('pPlane');
        if (pPlane)
            pPlane.visible = visibility;
    }
    flyTo(pos, time = 600, onComplete) {
        new Tween(this.model.position)
            .to(pos.clone(), time)
            .easing(TWEEN.Easing.Linear.None)
            .onComplete(() => onComplete && onComplete())
            .start();
    }
    setDefaultPositionRotation() {
        this.table.add(this.model);
        this.flyTo(this.defaultPosition, 600, () => this.visibilityShadow(true));
        this.rotateTo(new Euler(), 600);
    }
    rotateTo(newEuler, time = 600, delay = 0, onComplete) {
        const oldQuaternion = this.model.quaternion.clone();
        const newQuaternion = new Quaternion().setFromEuler(newEuler);
        new Tween({ alpha: 0 })
            .to({ alpha: 1 }, time)
            .easing(TWEEN.Easing.Linear.None)
            .onUpdate((alpha) => {
            const quat = oldQuaternion.clone().slerp(newQuaternion.clone(), alpha);
            this.model.quaternion.copy(quat);
        })
            .onComplete(() => onComplete && onComplete())
            .delay(delay)
            .start();
    }
    show(isVisible = true) {
        this.uiObject.visible = isVisible;
    }
}
